import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "Create Production")
], -1)
const _hoisted_2 = { class: "mb-10 fv-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "form-label mb-3 required" }, "Production Name", -1)
const _hoisted_4 = { class: "mb-0 fv-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, "Type of Production", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 fw-bold mb-5 mt-4" }, "This helps us know who is using StageHub, and helps us prioritize features that are suited for your production. ", -1)
const _hoisted_7 = { class: "d-flex flex-column justify-content-center mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Selector2 = _resolveComponent("Selector2")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    title: "Create Production",
    size: "modal-md",
    ref: "modal",
    "is-loading": _ctx.isLoading,
    "loading-text": "Creating Your Production"
  }, {
    body: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: _normalizeClass(["form-control form-control-lg", {'is-invalid': _ctx.v$.productionCommand.name.$error}]),
          name: "account_name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productionCommand.name) = $event))
        }, null, 2), [
          [_vModelText, _ctx.productionCommand.name]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Selector2, {
          options: _ctx.productionTypeOptions,
          modelValue: _ctx.productionCommand.type,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productionCommand.type) = $event))
        }, null, 8, ["options", "modelValue"]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Button, {
          "is-loading": _ctx.isLoading,
          onClick: _ctx.add
        }, {
          default: _withCtx(() => [
            _createTextVNode("Create Production")
          ]),
          _: 1
        }, 8, ["is-loading", "onClick"]),
        _createVNode(_component_Button, {
          onClick: _ctx.closeModal,
          type: "secondary",
          class: "d-md-none mt-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}